export { default } from './CDCProtegido25Protecao';
